<template>
  <finance-drawer
    title="补款单详情"
    width="70%"
    v-bind="$attrs"
    v-on="$listeners"
    :title-no="suppleOrderNo"
    :modal-close="false"
    @refresh="handleOpen"
  >
    <div slot="drawer-operation">
      <btns-operate :current="detailInfo" @success="init" :show="['WAIT'].includes(detailInfo.suppleStatus)" />
    </div>
    <div class="main-cont" v-loading="loading">
      <div class="main-cont-item">
        <h2 class="title-text">
          基础信息
          <icon-status
            :color="statusColorFilters(detailInfo.suppleStatus)"
            :status="detailInfo.suppleStatusDesc"
          />
        </h2>
        <el-row :gutter="20" style="margin-top: -8px;">
          <jr-col :data-show="firstCol" :data="detailInfo">
            <template #suppleReason>
              <jr-tooltip :content="detailInfo.suppleReason || '-'" />
            </template>
          </jr-col>
          <jr-col :data-show="secondCol" :data="detailInfo" />
          <jr-col :data-show="thirdCol" :data="detailInfo" />
        </el-row>
      </div>
      <div class="main-cont-item">
        <h2 class="title-text">补款到账信息</h2>
        <el-row :gutter="20" style="margin-top: -8px;">
          <jr-col :data-show="suppleFirstCol" :data="detailInfo" />
          <jr-col :data-show="suppleSecondCol" :data="detailInfo" />
          <jr-col :data-show="suppleThirdCol" :data="detailInfo" />
        </el-row>
      </div>
      <div class="main-cont-item">
        <h2 class="title-text">补款凭证</h2>
        <div>
          <div v-if="!detailInfo.certificate" class="no-certificate">无凭证</div>
          <jr-preview-image v-else :image-list="$stringToArray(detailInfo.certificate)|| []" :is-own="true" />
        </div>
      </div>
      <div class="main-cont-item" v-if="orderModifyList.length">
        <h2 class="title-text">订单修改申请信息</h2>
        <jr-table
          :size="formSize"
          :tableData="orderModifyList"
          :tableColumn="orderTableColumn"
        />
      </div>
      <div class="main-cont-item">
        <h2 class="title-text">补款申请信息</h2>
        <jr-table
          :size="formSize"
          :tableData="detailInfo.supplementApplyInfos"
          :tableColumn="tableColumn"
        />
      </div>
      <div class="main-cont-item">
        <h2 class="title-text">补款抵扣信息</h2>
        <jr-table
          :size="formSize"
          :tableData="detailInfo.relateDeductOrderDetails"
          :tableColumn="relateDeductTableColumn"
        />
      </div>
    </div>
  </finance-drawer>
</template>

<script>
import { getSupplementDetail } from '@/api/supplement';
import { getOrderDetail } from '@/api/approval/order';
import btnsOperate from './btns-operate';
import { setStatusColor } from '@/filters/index';

export default {
  props: {
    suppleOrderNo: {
      type: String,
      default: '',
    },
    applyNo: {
      type: String,
      default: '',
    },
  },
  components: { btnsOperate },
  data() {
    return {
      detailInfo: {},
      loading: false,
      // 基础信息
      firstCol: [
        { label: '客户编号:', prop: 'businessNo' },
        { label: '客户名称:', prop: 'businessName' },
        { label: '补款类型:', prop: 'suppleTypeDesc' },
        { label: '业务订单号:', prop: 'orderNumber' },
        { label: '服务商编号:', prop: 'payeeBusinessNo' },
        { label: '服务商名称:', prop: 'payeeBusinessName' },
        { label: '补款原因:', prop: 'suppleReason', slotName: 'suppleReason' },
      ],
      secondCol: [
        { label: '补款方式:', prop: 'suppleWayDesc' },
        { label: '补款渠道:', prop: 'suppleChannelDesc' },
        { label: '补款金额:', prop: 'suppleAmount', filters: 'toFenThousandsAndFloat(¥)' },
        { label: '补款到账时间:', prop: 'thirdFinishTime', filters: 'formatTime(yyyy-MM-dd)' },
        { label: '操作人:', prop: 'operator' },
        { label: '操作时间:', prop: 'operateTime', filters: 'formatTime' },
      ],
      thirdCol: [
        { label: '归属业务:', prop: 'sourceDesc' },
        { label: '业务类型:', prop: 'busiTypeDesc' },
        { label: '业务BD:', prop: 'bdId' },
        { label: '审核人:', prop: 'approver' },
        { label: '审核时间:', prop: 'approvalTime', filters: 'formatTime' },
        { label: '申请人:', prop: 'createUser' },
        { label: '申请时间:', prop: 'createTime', filters: 'formatTime' },
      ],
      suppleFirstCol: [
        { label: '收款户名:', prop: 'recAccountName' },
        { label: '支行名称:', prop: 'recBankBranchName' },
      ],
      suppleSecondCol: [
        { label: '收款账户:', prop: 'recAccountNumber' },
        { label: '账户类型:', prop: 'recAccountTypeDesc' },
      ],
      suppleThirdCol: [
        { label: '收款银行:', prop: 'recBankName' },
      ],
      tableColumn: [
        { label: '补款申请编号', prop: 'suppleApplyNo' },
        { label: '原交易单号', prop: 'orderNumber' },
        { label: '补款申请金额(元)', prop: 'suppleAmount', filterName: 'toFenThousandsAndFloat' },
        { label: '申请时间', prop: 'createTime', filterName: 'formatTime' },
        { label: '本次补款金额(元)', prop: 'suppleCurrentAmount', filterName: 'toFenThousandsAndFloat' },
      ],
      relateDeductTableColumn: [
        { label: '抵扣时间', prop: 'createTime', filterName: 'formatTime' },
        { label: '抵扣单号', prop: 'deductDetailNo' },
        { label: '抵扣金额(元)', prop: 'deductAmount', filterName: 'toFenThousandsAndFloat' },
        { label: '业务订单号', prop: 'refundOrderNum' },
        { label: '抵扣类型', prop: 'repayTypeDesc' },
        { label: '备注', prop: 'remark' },
      ],
      orderTableColumn: [
        { label: '申请编号', prop: 'applyNo' },
        { label: '订单编号', prop: 'orderNumber' },
        { label: '订单原金额(元)', prop: 'origShouldPayAmount', filterName: 'toFenThousandsAndFloat' },
        { label: '订单新金额(元)', prop: 'newShouldPayAmount', filterName: 'toFenThousandsAndFloat' },
        { label: '本次退款金额(元)', prop: 'supplementAmountByModify', filterName: 'toFenThousandsAndFloat' },
        { label: '申请时间', prop: 'crtime', filterName: 'formatTime' },
      ],
      orderModifyList: [],
    };
  },
  watch: {
    suppleOrderNo: {
      deep: true,
      handler() {
        if (this.suppleOrderNo) {
          this.handleOpen();
        }
      },
      immediate: true,
    },
  },
  methods: {
    // 打开窗口前
    handleOpen() {
      this.detailInfo = {};
      this.$nextTick(() => {
        this.init();
      });
    },
    init() {
      this.getApplyDetail();
      this.getOrderDetail();
    },
    statusColorFilters(status) {
      return setStatusColor(status, 'cancelStatus');
    },
    async getOrderDetail() {
      try {
        const res = await getOrderDetail({ applyNo: this.applyNo });
        this.orderModifyList = res.data ? [res.data] : [];
      } catch (error) {
        console.log(error);
        this.orderModifyList = [];
      }
    },
    // 获取详情接口
    async getApplyDetail() {
      try {
        this.loading = true;
        const res = await getSupplementDetail({ suppleOrderNo: this.suppleOrderNo });
        this.detailInfo = res.data || {};
      } catch (error) {
        console.log(error);
        this.detailInfo = {};
      } finally {
        this.loading = false;
      }
    },
    refreshList() {},
  },
};
</script>

